import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    FormAccess,
    FormAccessResponse,
    CreateFormAccessBody,
    createFormAccess,
    deleteFormAccess,
} from '../../services/apiSLTP/qhse/forms/formAccess';

// ---- TYPES ----
type UseCreateFormAccessMutationOptions = MutationOptions<FormAccessResponse, Error, CreateFormAccessBody>;
type UseDeleteFormAccessMutationOptions = MutationOptions<{ message: string }, Error, { formAccessId: string }>;

// ---- CREATE FORM ACCESS ----
export const useCreateFormAccessMutation = (options?: UseCreateFormAccessMutationOptions) => {
    const mutation: MutationFunction<FormAccessResponse, CreateFormAccessBody> = async (data) => {
        try {
            const response = await createFormAccess(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during createFormAccess');
        }
    };

    return useMutation(mutation, options);
};

// ---- DELETE FORM ACCESS ----
export const useDeleteFormAccessMutation = (options?: UseDeleteFormAccessMutationOptions) => {
    const mutation: MutationFunction<{ message: string }, { formAccessId: string }> = async ({ formAccessId }) => {
        try {
            const response = await deleteFormAccess(formAccessId);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during deleteFormAccess');
        }
    };

    return useMutation(mutation, options);
};
